var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-dropzone',{attrs:{"options":_vm.dropzoneOptions,"id":_vm.id},on:{"vdropzone-sending":_vm.addNameParameter,"vdropzone-success":_vm.uploaded}})}
var staticRenderFns = []

export { render, staticRenderFns }